import { render, staticRenderFns } from "./ClientesVendasVisualizar.vue?vue&type=template&id=f02df4be&lang=pug&"
import script from "./ClientesVendasVisualizar.vue?vue&type=script&lang=js&"
export * from "./ClientesVendasVisualizar.vue?vue&type=script&lang=js&"
import style0 from "./ClientesVendasVisualizar.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports